import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Syncs the native status bar text color with the current theme.
 * Only runs on native (iOS/Android) — no-op on web.
 */
export function useStatusBar() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let Style;
    let StatusBar;

    const init = async () => {
      try {
        const mod = await import('@capacitor/status-bar');
        StatusBar = mod.StatusBar;
        Style = mod.Style;
      } catch {
        return;
      }

      applyTheme();
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    };

    const applyTheme = () => {
      if (!StatusBar || !Style) return;
      const isDark = document.documentElement.classList.contains('dark');
      StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light }).catch(() => {});
    };

    const observer = new MutationObserver(applyTheme);

    init();

    return () => observer.disconnect();
  }, []);
}
